export default __webpack_public_path__ + "static/media/marking--discrete--arrow--split-left-or-straight.26ea6315.png";